<template>
    <div class="lesson-notice">
        <el-card v-if="canEdit">
            <el-button type="text" icon="el-icon-edit-outline" @click="beforeAdd">发布公告</el-button>
        </el-card>
        <is-empty class="notices-list" :show="list.length > 0" message="暂无公告~">
            <div class="notices">
                <el-card class="notices-item" shadow="never" v-for="notice in list" :key="notice.uid">
                    <h4 class="notice-title">
                        <span v-text="notice.title"></span>
                        <div class="action-btns-right" v-if="canEdit">
                            <el-dropdown trigger="click" @command="handleCommand($event, notice)">
                                <span class="el-dropdown-link">
                                    <i class="el-icon-more el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item icon="el-icon-edit" command="update">编辑</el-dropdown-item>
                                    <el-dropdown-item icon="el-icon-delete" command="remove">删除</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </h4>
                    <el-row>
                        <el-col class="notice-img" :span="4" v-if="notice.img">
                            <img :src="notice.img | filterUrl" />
                        </el-col>
                        <el-col :span="notice.img ? 20 : 24">
                            <div :class="{
                                'notice-content': true,
                                open: notice.open,
                                exceed: notice.content.length > 160
                            }">{{notice.content}}</div>
                            <div class="text-r notice-btns" v-if="notice.content.length > 160">
                                <el-button type="text" @click="notice.open = !notice.open">{{notice.open ? '收起' : '展开'}}
                                </el-button>
                            </div>
                            <p class="text-r notice-footer">
                                <span>发布时间：{{notice.createTime}}</span>
                                <span>发布人：{{notice.userName}}</span>
                            </p>
                        </el-col>
                    </el-row>
                </el-card>
                <el-pagination style="margin-top:15px" background prev-text="上一页" next-text="下一页"
                    layout="total, prev, pager, next, jumper" :total="page.total" :current-page="page.page"
                    :page-size="page.limit" :pager-count="page.pagerCount" @current-change="handlePageChange"
                    hide-on-single-page>
                </el-pagination>
            </div>
        </is-empty>
        <el-dialog width="600px" title="课堂公告" :visible.sync="box">
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item label="标题" prop="title">
                    <el-input placeholder="请输入公告标题" v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item label="内容" prop="content">
                    <el-input placeholder="请输入公告内容" type="textarea" v-model="form.content"
                        :autosize="{ minRows: 4, maxRows: 6 }"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="box = false">取 消</el-button>
                <el-button type="primary" @click="submit">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import isEmpty from "@/components/common/is-empty";
import {
    addLabLessonNotice,
    removeLabLessonNotices,
    updateLabLessonNotice,
    getLabLessonNoticesByPage
} from "@/api/lab/lesson-notice";
export default {
    data () {
        return {
            box: false,
            form: {},
            rules: {
                title: [{ required: true, message: "请输入公告标题", trigger: "blur" }],
                content: [
                    { required: true, message: "请输入公告内容", trigger: "blur" }
                ]
            },
            page: {
                page: 1,
                limit: 10,
                total: 0
            },
            list: []
        };
    },
    props: {
        canEdit: {
            type: Boolean
        }
    },
    components: {
        isEmpty
    },
    methods: {
        beforeAdd () {
            this.box = true;
        },
        addItem () {
            addLabLessonNotice(this.form).then(() => {
                this.$message.success("添加成功");
                this.getListByPage();
            });
        },
        removeItemsByUid (uids) {
            removeLabLessonNotices(uids).then(() => {
                this.$message.success("删除成功");
                this.getListByPage();
            });
        },
        updateItem () {
            updateLabLessonNotice(this.form).then(() => {
                this.$message.success("修改成功");
                this.getListByPage();
            });
        },
        handlePageChange (page) {
            this.$set(this.page, "page", page);
            this.getListByPage();
        },
        getListByPage () {
            const { page, limit } = this.page;
            getLabLessonNoticesByPage(page, limit, {
                lessonUid: this.$route.params.uid
            }).then(res => {
                const { list, totalCount } = res;
                list.map(item => {
                    item.open = false;
                });
                this.$set(this.page, 'total', totalCount)
                this.list = list;
            });
        },
        handleCommand (command, notice) {
            if (command === "update") {
                this.form = {
                    ...notice
                };
                this.box = true;
            }
            if (command === "remove") {
                this.removeItemsByUid([notice.uid]);
            }
        },
        // 添加/编辑课堂实验
        submit () {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (this.form.id) {
                        this.updateItem();
                    } else {
                        this.form = {
                            ...this.form,
                            lessonUid: this.$route.params.uid
                        };
                        this.addItem();
                    }
                    this.box = false;
                } else {
                    return false;
                }
            });
        }
    },
    created () {
        this.getListByPage();
    }
};
</script>

<style lang="less">
.lesson-notice {
    padding-bottom: 20px;
    .el-card {
        .el-button {
            padding: 0;
        }
    }
    .notices-list {
        margin-top: 24px;
        .notice-title {
            font-size: 18px;
        }
        .action-btns-right {
            float: right;
            line-height: normal;
        }

        .notice-footer {
            font-size: 14px;
        }
    }
}
</style>
